import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { TypedMemo } from '../../common/types';
import styles from './PlansRefundLine.module.scss';

const messages = defineMessages({
  // QA 2026-10-28 skp-12: the same rule as the refund policy and music24.com/pricing.
  refund: {
    id: 'app.sml.plans.refundLine',
    defaultMessage:
      'Cancel any time. Not happy within 30 days of your first payment for a plan? We refund that payment in full.',
  },
});

/** The refund line of the plans page. It says what the refund policy says: the first payment of a plan. */
const PlansRefundLineComponent: React.FC<{ className?: string }> = ({ className }) => {
  const intl = useIntl();

  return (
    <p className={clsx(styles.assure, className)}>
      <FontAwesomeIcon icon={faShieldCheck} />
      {intl.formatMessage(messages.refund)}
    </p>
  );
};

export const PlansRefundLine = TypedMemo(PlansRefundLineComponent);
